var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.wert != null)?_c('span',[_c('div',{staticClass:"battery"},[_c('div',{class:'battery-level ' + _vm.getBatterieStatusClass(_vm.wert),style:('height:' + (_vm.wert * 100) + '%')})]),_vm._v(" "+_vm._s(Math.ceil(_vm.wert * 100) + '%')+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }